import {createRouter, createWebHistory,} from "vue-router";
import Main from "@/views/Main.vue";
import AboutUs from "@/views/about/AboutUs.vue";
import Gallery from "@/views/gallery/Gallery.vue";


export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            component: Main
        },
        {
            path: '/about',
            component: AboutUs
        },
        {
            path: '/gallery',
            component: Gallery
        }
    ]
})